<template>
    <div>
        <section id="contact" class="contact-section">
            <div class="container">
                <div class="row">
                    <!--                    <div class=" col-12" id="contact">-->
                    <!--                        <h3 class="block_title col-12">CONTACT ME</h3>-->
                    <!--                    </div>-->
                    <div class="col-12 about-content-header text-center my-3">
                        <span class="water-text">Contact Me</span>
                        <h2 class="page-section-heading text-center mb-0">Contact Me</h2>
                        <div class="divider-custom">
                            <div class="divider-custom-line" />
                            <div class="divider-custom-icon">
                                <i class="fas fa-star" />
                            </div>
                            <div class="divider-custom-line" />
                        </div>
                    </div>
                    <div v-view="inContact" class="col-lg-6 contact-left pr-0">
                        <div class="contact-left-header d-flex justify-content-between mb-5">
                            <h2>Drop me a line</h2>
                            <img src="../../public/images/menu_img/mail-send (3).png" alt="" />
                        </div>
                        <div class="wrap-input100 validate-input" data-validate="Name is required">
                            <!--                            <span class="label-input100">Enter Your Name</span>-->
                            <input class="input100" type="text" name="name" placeholder="Enter Your Name" />
                            <span class="focus-input100" />
                        </div>
                        <div class="wrap-input100 validate-input" data-validate="Eamil is required">
                            <!--                            <span class="label-input100">Enter Your Email Address</span>-->
                            <input class="input100" type="email" name="email" placeholder="Enter Your Email" />
                            <span class="focus-input100" />
                        </div>
                        <div class="wrap-input100 validate-input" data-validate="Subject is required">
                            <!--                            <span class="label-input100">Subject</span>-->
                            <input class="input100" type="text" name="Subject" placeholder="Enter The Topic" />
                            <span class="focus-input100" />
                        </div>
                        <div class="wrap-input100 validate-input" data-validate="Message is required">
                            <!--                            <span class="label-input100">Message</span>-->
                            <textarea class="input100" name="message" placeholder="Your Message Here..." />
                            <span class="focus-input100" />
                        </div>
                        <div class="mt-3 text-center">
                            <a href="">
                                <button class="btn btn-outline- send_btn btn-lg">
                                    Send <i class="fas fa-paper-plane" />
                                </button>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6 pl-0 pr-0">
                        <div class="contact-right">
                            <div class="contact-right-body">
                                <!--                                <div class="contact-right-heading">-->
                                <!--                                    <h2 class="text-center">More About Me</h2>-->
                                <!--                                    <p>-->
                                <!--                                        -->
                                <!--                                    </p>-->
                                <!--                                </div>-->
                                <div class="contact-right-content text-white mt-5">
                                    <div class="mb-5">
                                        <h3><i class="fas fa-map-marker-alt fa-2x contact_icon" />Address</h3>
                                        <p>
                                            Sector-12, Road-12<br />
                                            Uttara, Dhaka <br />
                                            Bangladesh<br />
                                        </p>
                                    </div>
                                    <div class="mb-5">
                                        <h3><i class="fa fa-phone cl-atlantis fa-2x contact_icon" /> Phone</h3>
                                        <p>+8801785336833</p>
                                    </div>
                                    <div class="mb-5">
                                        <h3><i class="far fa-envelope fa-2x contact_icon" /> Email</h3>
                                        <address class="address-details-f">
                                            <!--                                            Fax: 800 123 3456 <br />-->
                                            Email: <a class="">shamsiarhamid@gmail.com</a>
                                        </address>
                                    </div>
                                    <div class="">
                                        <ul class="d-flex list-inline social-icon-f top-data">
                                            <li class="">
                                                <a href="https://www.facebook.com/shamsiarhamid/" target="_empty"
                                                    ><i
                                                        class="fab fa-2x top-social fa-facebook"
                                                        style="color: #4267b2; border-color: #4267b2"
                                                /></a>
                                            </li>
                                            <!--                                            <li class="ml-5">-->
                                            <!--                                                <a href="#" target="_empty"><i class="fab fa-2x  top-social fa-twitter" style="color: #4AB3F4; border-color:#4AB3F4;"></i></a>-->
                                            <!--                                            </li>-->
                                            <li class="ml-5">
                                                <a href="https://github.com/shamsiar" target="_empty"
                                                    ><i class="fab fa-github fa-2x" style="color: white"
                                                /></a>
                                            </li>
                                            <li class="ml-5">
                                                <a
                                                    href="https://www.linkedin.com/in/shamsiar-hamid-ba7549136/"
                                                    target="_empty"
                                                    ><i class="fab fa-linkedin fa-2x" style="color: #833ab4"
                                                /></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    methods: {
        inContact() {
            this.$emit("inContact");
        },
    },
};
</script>

<style lang="scss" scoped></style>
